import { IUser, Roles } from '@shs-digi-care-monorepo/interfaces';

export function isAdmin(user: IUser | undefined | null): boolean {
    return !!user?.roles?.includes(Roles.ADMIN);
}

export function isTaskOwner(user: IUser | undefined | null): boolean {
    return !!user?.roles?.some((role) => [Roles.ADMIN, Roles.TASK_OWNER].includes(role as Roles));
}

export function isInternal(user: IUser | undefined | null): boolean {
    return isTaskOwner(user) || !!user?.roles?.includes(Roles.INTERNAL);
}

/**
 * Checks if the user has only the 'Requestor' role
 */
export function isRequestor(user: IUser | null | undefined): boolean {
    return user ? !!user?.roles?.includes(Roles.REQUESTOR) && user.roles.length === 1 : false;
}
